module.exports = __webpack_public_path__ + "56c972b2b5fa7e7717180eb072563b73.svg";